import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { TiTick } from "react-icons/ti";
import ReactStars from "react-rating-stars-component";

const EditProjectModal = (props) => {
  const {modalType, changedField}= props

  

  return (
    <div>
      <Modal size="md" isOpen={props.show} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>Edit Project</ModalHeader>
      <ModalBody>
      <div className="row ">
  <div className="col-lg-12">
    <div className="">
      
      <div className="d-flex justify-content-center align-items-center">
        <div className="form-validation">
         {modalType==='edit'||modalType==='add'? 
          <form  className="item-form card no-hover" >
          <div className="row">
              <div className="col-12">
                  <div className="form-group mt-3">
                      <input type="text" className="form-control" name="project" placeholder="Project name" value={props.changedField.projectname} onChange={(e)=>props.setChangedField(prev=>({...prev, projectname:e.target.value}))} required />
                  </div>
              </div>
              {/* <div className="col-12">
                  <div className="input-group form-group">
                      <div className="custom-file">
                          <input type="file" className="custom-file-input" onChange={(e)=>setImage(e.target.files[0])} name="image" id="inputGroupFile01" />
                          <label className="custom-file-label" htmlFor="inputGroupFile01">Project Image</label>
                      </div>
                  </div>
              </div> */}
              <div className="col-12">
                  <div className="form-group mt-3">
                      <textarea className="form-control" name="description" placeholder="Description" cols={30} rows={3}  required value={props.changedField.description} onChange={(e)=>props.setChangedField(prev=>({...prev, description:e.target.value}))} />
                  </div>
              </div>
              <div className="col-12">
                  <div className="form-group mt-3">
                      <input type="text" className="form-control" name="collectionsize" placeholder="Collection Size" required value={props.changedField.collectionSize} onChange={(e)=>props.setChangedField(prev=>({...prev, collectionSize:e.target.value}))} />
                  </div>
              </div>
              <div className="col-12">
                  <div className="form-group mt-3">
                      <input type="text" className="form-control" name="mintprice" placeholder="Mint Price" required value={props.changedField.mintPrice} onChange={(e)=>props.setChangedField(prev=>({...prev, mintPrice:e.target.value}))} />
                  </div>
              </div>
              <div className="col-12">
                  <div className="form-group mt-3">
                      <input type="text" className="form-control" name="mintrevenue" placeholder="Mint Revenue" required value={props.changedField.mintRevenue} onChange={(e)=>props.setChangedField(prev=>({...prev, mintRevenue:e.target.value}))}/>
                  </div>
              </div>
               <div className="col-12">
                  <div className="form-group mt-3">
                      <select className="form-select"  required  name='teamstatus' onChange={(e)=>props.setChangedField(prev=>({...prev, teamStatus:e.target.value}))}
                      value={changedField.teamStatus}   aria-label="Default select example">
                          <option disabled value='0'>Team Status</option>
                          
                          <option value="1">Doxxed</option>
                          <option value="2">Undoxxed</option>
                          </select>
                  </div>
              </div>
              {/*
              <div className="col-12">
                  <div className="form-group mt-3">
                      <select className="form-select"   required name='utilities'     aria-label="Default select example">
                          <option disabled value='0'>Utilities</option>
                          <option value="1">Yes</option>
                          <option value="2">No</option>
                          </select>
                  </div>
              </div> */}

              <div className="col-12">
                  <div className="form-group mt-3">
                      <input type="text" className="form-control" name="website" placeholder="Website" required value={props.changedField.website} onChange={(e)=>props.setChangedField(prev=>({...prev, website:e.target.value}))} />
                  </div>
              </div>
              <div className="col-12">
                  <div className="form-group mt-3">
                      <input type="text" className="form-control" name="twitter" placeholder="Twitter link" required value={props.changedField.twitter} onChange={(e)=>props.setChangedField(prev=>({...prev, twitter:e.target.value}))} />
                  </div>
              </div>
              <div className="col-12">
                  <div className="form-group mt-3">
                      <input type="text" className="form-control" name="twitterFollowers" placeholder="Twitter Follower" value={props.changedField.twitterFollowers} onChange={(e)=>props.setChangedField(prev=>({...prev, twitterFollowers:e.target.value}))} />
                  </div>
              </div>
              <div className="col-12">
                  <div className="form-group mt-3">
                      <input type="text" className="form-control" name="discord" placeholder="Discord link" required value={props.changedField.discord} onChange={(e)=>props.setChangedField(prev=>({...prev, discord:e.target.value}))} />
                  </div>
              </div>
              <div className="col-12">
                  <div className="form-group mt-3">
                      <input type="text" className="form-control" name="discordMember" placeholder="Discord members" value={props.changedField.discordMember} onChange={(e)=>props.setChangedField(prev=>({...prev, discordMember:e.target.value}))} />
                  </div>
              </div>
              <div className="col-12">
                  <div className="form-group mt-3">
                      <input type="text" className="form-control" name="magiceden" placeholder="magic Eden" required value={props.changedField.megiceden} onChange={(e)=>props.setChangedField(prev=>({...prev, megiceden:e.target.value}))} />
                  </div>
              </div>
              <div className="col-12">
                  <div className="form-group mt-3">
                      <textarea className="form-control" name="summary" placeholder="Summary (put comma to separate)" cols={30} rows={3}  value={props.changedField.summary} onChange={(e)=>props.setChangedField(prev=>({...prev, summary:e.target.value}))}/>
                  </div>
              </div>
              
          </div>
      </form>
          :
          <div>
          <div className="form-group row">
                 <label className="col-lg-4 col-form-label" ><span className="badge badge-info">Name:</span>
                 </label>
                 <div className="col-lg-8">
                   <p className="mt-2 badge badge-dark">{props.changedField.name}</p>
                 </div>
               </div>
          
               <div className="form-group row">
                 <label className="col-lg-4 col-form-label" ><span className="badge badge-info">Email:</span>
                 </label>
                 <div className="col-lg-8">
                   <p className="mt-2 badge badge-dark">{props.changedField.email}</p>
                 </div>
               </div>
               <div className="form-group row">
                 <label className="col-lg-4 col-form-label" ><span className="badge badge-info ">Phone:</span>
                 </label>
                 <div className="col-lg-8">
                   <p className="mt-2 ">{props.changedField.phone? <span className="badge badge-dark">{ props.changedField.phone}</span> : <span className="badge badge-pill badge-secondary">Not Added</span> }</p>
                 </div>
               </div>
          </div>}
        </div>
      </div>
    </div>
  </div>

</div>
      </ModalBody>
      <ModalFooter>
       
        <Button style={{padding:'7px 10px'}} color="secondary" onClick={props.toggle}>
          {modalType==='edit' ?'Cancel' : 'Close'}
        </Button>{' '}
       {modalType !=='view' &&  <Button style={{padding:'7px 10px'}} color="primary" onClick={modalType==='edit'?props.handleSubmit : props.handleSubmit&& props.handleSubmit}>
          Submit
        </Button>}
      </ModalFooter>
    </Modal>

</div>
  )
}

export default EditProjectModal
